import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from './manage-survey.model';

export const RECONCILIATION_HANDLERS = [
  on(
    ManageSurveyActions.loadReconciliationAttempts,
    (state): ManageSurveyState => ({
      ...state,
      reconciliationAttemptsLoading: true,
      reconciliationAttemptsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadReconciliationAttemptsSuccess,
    (state, { reconciliationAttempts }): ManageSurveyState => ({
      ...state,
      reconciliationAttempts,
      reconciliationAttemptsLoading: false,
      reconciliationAttemptsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadReconciliationAttemptsFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      reconciliationAttempts: [],
      reconciliationAttemptsLoading: false,
      reconciliationAttemptsError: error,
    }),
  ),
];
